import http from "./storageManager/methods/http";
import { RADIUS } from "./common/constants";
import { getConfig } from "./config/localizerConfig";

const localizationServiceProxy = {
  config: getConfig(),
  async getStoreFromSSS(storeId) {
    const validStoreId = Number(storeId);
    if (!validStoreId) {
      throw new Error("Valid Store ID is required");
    }
    const storeSearchServiceUrl = `${this.config.host}${this.config.storeSearchService}?type=json&storeid=${validStoreId}`;
    return await http.get(storeSearchServiceUrl);
  },
  async getLocalStore(coordinates) {
    let urlParams = "";
    if (coordinates) {
      if (Number(coordinates.latitude)) {
        urlParams += `latitude=${coordinates.latitude}&`;
      }
      if (Number(coordinates.longitude)) {
        urlParams += `longitude=${coordinates.longitude}&`;
      }
      if (Number(coordinates.accuracy)) {
        urlParams += `accuracy=${coordinates.accuracy}&`;
      }
    }
    const url = `${this.config.localizationApiHost}${this.config.service}.jsonp?${urlParams}show=metadata,localstore`;
    return await http.get(url, true);
  },
  async getMetadata() {
    const localizationServiceUrl = `${this.config.localizationApiHost}${this.config.service}.jsonp?show=metadata`;
    return await http.get(localizationServiceUrl, true);
  },
  async getNearestStoreByRadius(coordinates) {
    const { latitude, longitude } = coordinates || {};
    if (!Number(latitude) || !Number(longitude)) {
      return;
    }
    const localizationServiceUrl = `${this.config.host}/StoreSearchServices/v2/storesearch?radius=${RADIUS}&latitude=${latitude}&longitude=${longitude}&type=json&pagesize=20`;
    return await http.get(localizationServiceUrl);
  },
  async getStoreNearby(queryparam) {
    const nearByStoreSearchServiceUrl = `${this.config.host}${this.config.storeSearchService}${queryparam}`;
    return await http.get(nearByStoreSearchServiceUrl);
  },
};

export default localizationServiceProxy;
